const getInitialState = () => {
  return {
    date: [],
    option: '',
    customer: '',
    customerAlias: '',
    transporter: '',
    vehicleType: '',
    titleReport: '',
    category: '',
    subCategory: '',
  }
}

const state = getInitialState()

const getters = {
  getDate: state => state.date,
  getOption: state => state.option,
  getCustomer: state => state.customer || '',
  getCustomerAlias: state => state.customerAlias || '',
  getTransporter: state => state.transporter || '',
  getVehicleType: state => state.vehicleType || '',
  getTitleReport: state => state.titleReport || 'Laporan',
  getCategory: state => state.category || '',
  getSubCategory: state => state.subCategory || '',
}

const mutations = {
  setDate (store, data) {
    store['date'] = data
  },
  setOption (store, data) {
    store['option'] = data
  },
  setCustomer (store, data) {
    store['customer'] = data
  },
  setCustomerAlias (store, data) {
    store['customerAlias'] = data
  },
  setTransporter (store, data) {
    store['transporter'] = data
  },
  setVehicleType (store, data) {
    store['vehicleType'] = data
  },
  setTitleReport (store, data) {
    store['titleReport'] = data
  },
  setCategory (store, data) {
    store['category'] = data
  },
  setSubCategory (store, data) {
    store['subCategory'] = data
  },
  resetState (state) {
    // Merge rather than replace so we don't lose observers
    // https://github.com/vuejs/vuex/issues/1118
    Object.assign(state, getInitialState())
  }
}

export default {
  namespaced: true,
  getters,
  state,
  mutations
}
